<div class="row">
    <div class="col-xl-7">
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="font-size-lg d-block text-truncate">
                    <span class="text-black-50 pr-2">#32</span> Global competition
                </div>
                <div class="ml-auto d-flex align-items-center align-content-center">
                    <div class="avatar-wrapper-overlap">
                        <div class="avatar-icon-wrapper" placement="top"
                             containerClass="tooltip-secondary" tooltip="Emilee Ryder">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar7.jpg"/></div>
                        </div>
                        <div class="avatar-icon-wrapper" placement="top"
                             containerClass="tooltip-secondary" tooltip="Tobi Esparza">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                        </div>
                    </div>
                    <a [routerLink]="" class="btn btn-first font-size-lg ml-3 d-40 p-0 rounded-circle border-0"

                      tooltip="View all participants">
                        <fa-icon [icon]="['far', 'building']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <div class="text-center">
                            <span class="text-black-50 d-block">Users</span>
                            <b class="font-size-xxl">2,345</b>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="text-center">
                            <span class="text-black-50 d-block">Revenue</span>
                            <b class="font-size-xxl">$9,693</b>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 align-box-row">
                        <div class="w-100 mt-3 mt-md-0">
                            <div class="mb-1">
                                <span class="text-black-50 pr-1">Progress:</span>
                                                <span class="text-danger">-12</span>
                            </div>
                            <div class="progress-bar-sm progress-bar-animated-alt progress">
                                <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="43"
                                     class="progress-bar bg-success" role="progressbar" style="width: 43%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="font-size-lg d-block text-truncate">
                    <span class="text-black-50 pr-2">#33</span> International Event
                </div>
                <div class="ml-auto d-flex align-items-center align-content-center">
                    <div class="avatar-wrapper-overlap">
                        <div class="avatar-icon-wrapper" placement="top"
                             containerClass="tooltip-secondary" tooltip="Ayah Dunkley">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                        </div>
                        <div class="avatar-icon-wrapper" placement="top"
                             containerClass="tooltip-secondary" tooltip="Rumaysa Quinn">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar7.jpg"/></div>
                        </div>
                        <div class="avatar-icon-wrapper" placement="top"
                             containerClass="tooltip-secondary" tooltip="Kean Banks">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                        </div>
                    </div>
                    <a [routerLink]="" class="btn btn-first font-size-lg ml-3 d-40 p-0 rounded-circle border-0"

                      tooltip="View all participants">
                        <fa-icon [icon]="['far', 'building']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <div class="text-center">
                            <span class="text-black-50 d-block">Users</span>
                            <b class="font-size-xxl">2,345</b>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="text-center">
                            <span class="text-black-50 d-block">Revenue</span>
                            <b class="font-size-xxl">$9,693</b>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 align-box-row">
                        <div class="w-100 mt-3 mt-md-0">
                            <div class="mb-1">
                                <span class="text-black-50 pr-1">Progress:</span>
                                                <span class="text-danger">-12</span>
                            </div>
                            <div class="progress-bar-sm progress-bar-animated-alt progress">
                                <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="43"
                                     class="progress-bar bg-success" role="progressbar" style="width: 43%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-box mb-5">
            <ul class="list-group list-group-flush">
                <li class="list-group-item p-0">
                    <div class="card-header bg-light">
                        <div class="font-size-lg d-block text-truncate">
                            <span class="text-black-50 pr-2">#34</span> Hackathon
                        </div>
                        <div class="ml-auto d-flex align-items-center align-content-center">
                            <div class="avatar-wrapper-overlap">
                                <div class="avatar-icon-wrapper" placement="top"
                                     containerClass="tooltip-secondary"
                                    tooltip="Rodrigo Barrera">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                                </div>
                                <div class="avatar-icon-wrapper" placement="top"
                                     containerClass="tooltip-secondary"
                                    tooltip="Tobi Esparza">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar6.jpg"/></div>
                                </div>
                            </div>
                            <a [routerLink]=""
                               class="btn btn-first font-size-lg ml-3 d-40 p-0 rounded-circle border-0"
                              tooltip="View all participants">
                                <fa-icon [icon]="['far', 'building']"></fa-icon>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6 col-md-3">
                                <div class="text-center">
                                    <span class="text-black-50 d-block">Users</span>
                                    <b class="font-size-xxl">2,345</b>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="text-center">
                                    <span class="text-black-50 d-block">Revenue</span>
                                    <b class="font-size-xxl">$9,693</b>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 align-box-row">
                                <div class="w-100 mt-3 mt-md-0">
                                    <div class="mb-1">
                                        <span class="text-black-50 pr-1">Progress:</span>
                                                <span class="text-danger">-12</span>
                                    </div>
                                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                                        <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="43"
                                             class="progress-bar bg-success" role="progressbar"
                                             style="width: 43%;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item p-0">
                    <div class="card-header bg-light">
                        <div class="font-size-lg d-block text-truncate">
                            <span class="text-black-50 pr-2">#33</span> Gaming center
                        </div>
                        <div class="ml-auto d-flex align-items-center align-content-center">
                            <div class="avatar-wrapper-overlap">
                                <div class="avatar-icon-wrapper" placement="top"
                                     containerClass="tooltip-secondary"
                                    tooltip="Karson Kline">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar6.jpg"/></div>
                                </div>
                            </div>
                            <a [routerLink]=""
                               class="btn btn-first font-size-lg ml-3 d-40 p-0 rounded-circle border-0"
                              tooltip="View all participants">
                                <fa-icon [icon]="['far', 'building']"></fa-icon>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6 col-md-3">
                                <div class="text-center">
                                    <span class="text-black-50 d-block">Users</span>
                                    <b class="font-size-xxl">1,466</b>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="text-center">
                                    <span class="text-black-50 d-block">Revenue</span>
                                    <b class="font-size-xxl text-danger">$6,465</b>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 align-box-row">
                                <div class="w-100 mt-3 mt-md-0">
                                    <div class="mb-1">
                                        <span class="text-black-50">Progress:</span>
                                        <span class="text-warning">-5</span>
                                    </div>
                                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                                        <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="43"
                                             class="progress-bar bg-warning" role="progressbar"
                                             style="width: 43%;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-xl-5">
        <div class="card card-box mb-5">
            <div class="px-4 px-xl-5 pb-1">
                <div class="card-header d-block">
                    <span class="text-uppercase py-3 py-xl-4 text-black d-block text-center font-weight-bold font-size-lg">Inventory</span>
                </div>
                <div class="card-body p-0">
                    <div class="grid-menu grid-menu-2col">
                        <div class="no-gutters row">
                            <div class="col-6 p-3">
                                <div class="text-center">
                                    <fa-icon [icon]="['fas', 'lemon']" class="font-size-xxl text-warning my-3"></fa-icon>
                                    <span class="text-black-50 d-block">Users</span>
                                    <b class="font-size-xxl">2,345</b>
                                </div>
                            </div>
                            <div class="col-6 p-3">
                                <div class="text-center">
                                    <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success my-3"></fa-icon>
                                    <span class="text-black-50 d-block">Revenue</span>
                                    <b class="font-size-xxl">$9,693</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-header border-0 d-block">
                    <span class="text-uppercase pt-4 pb-2 text-black d-block text-center font-weight-bold font-size-lg">Activity</span>
                </div>
                <div>
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0" tooltip="View details"
                            >
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar7.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [value]="43" class="progress-bar-rounded" type="success">
                                43%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <b class="font-size-lg text-success">
                                <small class="text-black-50">$</small>
                                1,754</b>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0" tooltip="View details"
                            >
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar5.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [value]="61" class="progress-bar-rounded" type="info">
                                61%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <b class="font-size-lg text-info">
                                <small class="text-black-50">$</small>
                                7,428</b>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0" tooltip="View details">
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [value]="22" class="progress-bar-rounded" type="danger">
                                22%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <b class="font-size-lg text-danger">
                                <small class="text-black-50">$</small>
                                5,358</b>
                        </div>
                    </div>
                </div>
                <div class="card-header border-0 d-block">
                    <span class="text-uppercase pb-1 pt-1 text-black d-block text-center font-weight-bold font-size-lg">Charts</span>
                </div>
                <apx-chart
                        [chart]="{
                        type: 'area',
                        height: '150',
                        sparkline: {
                          enabled: true
                        }
                    }"
                        [colors]="['#f4772e']"
                        [fill]="{
                        color: '#f4772e'
                    }"
                        [series]="[
                      {
                        name: 'Sales',
                        data: [ 32, 52, 45, 32, 54, 56, 28, 25, 36, 62]
                      }
                    ]"
                        [stroke]="{
                        color: '#4191ff',
                        curve: 'smooth',
                        width: 2
                    }"

                        [xaxis]="{
                        crosshairs: {
                            width: 1
                        }
                    }"
                        [yaxis]="{
                        min: 0
                    }"
                ></apx-chart>
            </div>
            <div class="card-footer d-block text-center">
                <a [routerLink]="" class="btn btn-sm btn-success" tooltip="Refresh">
                    <fa-icon [icon]="['fas', 'cog']" [spin]="true"></fa-icon>
                </a>
            </div>
        </div>
    </div>
</div>
